import React, { useMemo } from 'react';
import { DateUtils } from '@vectord/utils';
import orderBy from 'lodash/orderBy';

import { useFilteredSbatGroups } from 'features/classCreation';
import ErrorLayout from 'components/ErrorLayout';
import RescheduleClassesButton from '../RescheduleClassesButton';
import ScheduledClassesTable from '../ScheduledClassesTable';
import SelectAllUpcomingSbatGroupsButton from '../SelectAllUpcomingSbatGroupsButton';
import styles from './UpcomingClassesTable.module.scss';

export default function UpcomingClassesTable({ sbatGroups }) {
  const upcomingSbatGroups = useMemo(
    () =>
      orderBy(
        sbatGroups.filter(
          (sbatGroup) =>
            new Date(sbatGroup.date_of_topic) >= Date.now() - DateUtils.ONE_HOUR
        ),
        (o) => new Date(o.date_of_topic),
        'asc'
      ),
    [sbatGroups]
  );

  const filteredSbatGroups = useFilteredSbatGroups(upcomingSbatGroups);

  if (filteredSbatGroups.length > 0) {
    return (
      <>
        <div className={styles.root}>
          <RescheduleClassesButton className="m-l-xs" />
          <SelectAllUpcomingSbatGroupsButton sbatGroups={filteredSbatGroups} />
        </div>
        <ScheduledClassesTable
          sbatGroups={filteredSbatGroups}
          isSelectable
        />
      </>
    );
  } else {
    return <ErrorLayout message="No upcoming classes are there!" />;
  }
}
